/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './muteActor.defs.js'
export { main as default } from './muteActor.defs.js'
